import { tokenKeyName } from '../constants';
var isClient = typeof localStorage !== 'undefined';
export function setSession(accessToken) {
  if (isClient) {
    if (accessToken) localStorage.setItem(tokenKeyName, accessToken);else localStorage.removeItem(tokenKeyName);
  }
}